var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnselectedConnectedPowerStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 34,
    viewBox: "0 0 25 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C6.1211 1 1 6.47493 1 13.0826C1 19.6903 12.5 33 12.5 33C12.5 33 24 19.7847 24 13.0826C24 6.38053 18.7891 1 12.5 1Z",
    fill: "#1E4247",
    stroke: "#1E4247",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7808 6.68152C15.7746 6.78947 18.087 7.88743 20.4255 9.53976C20.9205 9.88043 21.3218 10.2638 21.723 10.6472C22.167 11.1244 22.2097 11.2182 21.7325 11.6622C21.4939 11.8842 21.3064 11.9696 21.0678 12.1916C20.6416 12.4991 20.5479 12.5418 20.1466 12.1584C18.8064 10.9571 17.1338 10.0206 15.3509 9.58737C11.5119 8.61882 8.73182 8.97976 5.27992 11.3456C4.76 11.6958 4.66622 11.7386 4.22225 11.2614C4.00026 11.0228 3.77828 10.7842 3.59903 10.6394C3.19779 10.256 3.24883 10.1195 3.67498 9.81201C6.14638 7.77971 9.37751 6.42045 12.7808 6.68152Z",
    fill: "#FEC867"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6474 14.0874C18.7839 14.1384 18.2129 14.6251 18.1619 14.7616C18.0171 14.9409 17.7358 15.0691 17.5399 15.3848C17.3013 15.6068 17.071 15.5985 16.7553 15.4027C15.5516 14.2524 14.0499 13.691 12.4379 13.6329C10.9624 13.6258 9.65782 13.9938 8.33664 14.8224C7.81672 15.1726 7.72295 15.2153 7.27898 14.7382C7.05699 14.4996 6.835 14.261 6.61302 14.0224C6.30556 13.5962 6.3566 13.4597 6.68897 13.195C7.92467 12.1788 9.37405 11.6316 10.9944 11.4594C13.6807 11.1412 16.0524 11.8724 18.1096 13.6529C18.2462 13.704 18.4254 13.8488 18.6474 14.0874Z",
    fill: "#FEC867"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70326 16.5782L9.60949 16.6209C9.42193 16.7064 9.36259 17.0732 9.54184 17.218L9.8493 17.6441C10.114 17.9765 10.1057 18.2068 10.5236 18.1296C10.8476 18.0952 11.5978 17.7533 12.2887 17.7782C12.8858 17.8459 13.1588 17.9479 13.5684 18.1011C14.2082 18.2625 14.975 17.46 15.3074 17.1953C15.4011 17.1526 15.3584 17.0588 15.3157 16.965C13.6514 15.7982 11.3995 15.5786 9.70326 16.5782Z",
    fill: "#FEC867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedConnectedPowerStation);
export default __webpack_public_path__ + "static/media/unselected-connected-power-station.d1760ef959102eb5bc2166a2d7210c6d.svg";
export { ForwardRef as ReactComponent };